<div *ngIf="isLoading | async">
  <div class="spinner-overlay">
    <div class="spinner-border text-primary" role="status"></div>
    <div class="spinner-body">
      <h2 class="spinner-message">{{message | async}}</h2>
    </div>
  </div>
  <div class="spinner-overlay-backdrop show"></div>
</div>